import { Component, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { Theme } from '@mui/material';
import { WithStyles, createStyles, withStyles } from '@mui/styles';

const styles = (theme: Theme) =>
    createStyles({
        container: {
            padding: theme.spacing(3),
        },
        headerName: {
            fontSize: '16px',
            fontWeight: 'bold',
            lineHeight: '22px',
            color: '#2E3333',
            display: 'block',
        },
        headerBestOffer: {
            fontSize: '11px',
            lineHeight: '13px',
            color: theme.palette.primary.main,
            textTransform: 'uppercase',
            '&:empty:before': {
                content: '"\\200b"',
            },
        },
    });

interface PriceMatrixHeaderProps extends WithStyles<typeof styles> {
    name: ReactNode;
    bestOffer: boolean;
}

export const PriceMatrixHeader = withStyles(styles)(
    class PriceMatrixHeaderBase extends Component<PriceMatrixHeaderProps> {
        public render() {
            const { classes, name, bestOffer } = this.props;
            return (
                <div className={classes.container}>
                    <span className={classes.headerName}>{name}</span>
                    <span className={classes.headerBestOffer}>
                        {bestOffer && <FormattedMessage id="app.priceMatrix.bestOffer" />}
                    </span>
                </div>
            );
        }
    }
);
